<template>
  <div class="modal fade" id="addNewCPAModal" tabIndex="-1" aria-labelledby="addNewCPAModalTitle" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">

        <div class="modal-header">
          <h5 class="modal-title text-left mt-1" id="addNewCPAModalTitle">Add new column</h5>
          <button type="button" id="closeModalButton" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <div class="modal-body">

          <div class="form-row">
            <div class="form-group col text-left">
              <label for="newKnowledgePropertySelection">Select new Knowledge Property</label>
              <div class="input-group disabled">
                <!--
                <a href="#" role="button" class="btn btn-secondary popover-test" title="Find Knowledge Properties" v-on:click="findKnowledgeProperties">Find Knowledge Properties</a>
                -->
                <div v-if="!autoLoadingForKnowledgeProperties" href="#" role="button" class="btn btn-secondary" title="Find Knowledge Properties" v-on:click="findKnowledgeProperties">
                  <span class="mr-0 icon icon-software-update"></span>
                </div>

                <select v-if="!autoLoadingForKnowledgeProperties || !isLoadingKnowledgeProperties" class="custom-select" :disabled="knowledgePropertiesList.length <= 0" id="newKnowledgePropertySelection" v-model="newKnowledgePropertySelection" v-on:change="newKnowledgePropertySelectionChange">

                  <option>{{ choiceTextForKnowledgePropertySelection }}</option>
                  <option v-for="knowledgeProperty of knowledgePropertiesList" :key="knowledgeProperty.pLabel">{{ knowledgeProperty.pLabel }}</option>

                </select>

                <div v-if="autoLoadingForKnowledgeProperties && isLoadingKnowledgeProperties" class="col-12 px-0" id="isLoadingKnowledgePropertiesSelection">
                  <div class="px-2 d-flex align-items-center" :style="{'position': 'relative', 'border': '.125rem solid #cccccc', 'background-color': '#eeeeee', 'color': '#666666', 'padding-bottom': '4px', 'padding-top': '2px'}">
                    <div class="spinner-border spinner-border-sm m-1 " role="status">
                    </div>
                    <strong class="mt-1">Loading Knowledge Properties... </strong>
                  </div>
                </div>

              </div>

            </div>
          </div>

          <table class="table table-sm mb-0 headerAlwaysVisible">
            <thead>
              <tr ref="displayed_table_first_line" class="pb-0 mb-0 border-bottom-0">
                <th class="pl-0 pr-0 pb-0 pt-1">
                  <div class="d-flex shadow-sm">
                    <div class="d-flex flex-fill justify-content-center">
                      <div class="d-flex flex-column my-auto">
                        <b v-if="headerName === undefined"> -- header -- </b>
                        <b v-if="headerName !== undefined">{{ headerName }}</b>
                      </div>
                    </div>
                  </div>
                </th>
                <th class="pl-0 pr-0 pb-0 pt-1">
                  <div class="d-flex shadow-sm">
                    <div class="d-flex flex-fill justify-content-center">
                      <div class="d-flex flex-column my-auto">
                        <b v-if="newKnowledgePropertySelection === choiceTextForKnowledgePropertySelection"> -- property value -- </b>
                        <b v-if="newKnowledgePropertySelection !== choiceTextForKnowledgePropertySelection">{{ newKnowledgePropertySelection }}</b>
                      </div>
                    </div>
                  </div>
                </th>
              </tr>
            </thead>

            <tr class="shadow-sm" v-for="(element,i) in startColumn" :key="'tr-'+i">
              <td class="border border-300">

                <CellContentDisplayer :initialText="element.initialText" :ceaIsMerged="element.ceaIsMerged" :ceaIsDefined="element.ceaIsDefined" :ceaLabel="element.ceaLabel" :ceaLink="element.ceaLink" :ceaScore="element.ceaScore" />

              </td>

              <td class="border border-300 p-1">

                <CellContentDisplayer v-if="(selectedKnowledgeProperty !== undefined) && (selectedKnowledgeProperty.propertyValues !== undefined) && (selectedKnowledgeProperty.propertyValues[i].length !== 0)" :isKnowledgeValueProperty="selectedKnowledgeProperty.isValueProperty" :isKnowledgeUrlProperty="selectedKnowledgeProperty.isUrlProperty" :isKnowledgeItemProperty="selectedKnowledgeProperty.isItemProperty" :knowledgeProperty="selectedKnowledgeProperty.propertyValues[i]" />
                <CellContentDisplayer v-if="(selectedKnowledgeProperty === undefined) || (selectedKnowledgeProperty.propertyValues === undefined) || (selectedKnowledgeProperty.propertyValues[i].length === 0)" :knowledgeProperty="undefined" />

              </td>
            </tr>
          </table>
        </div>

        <div class="form-row mt-4">
          <div class="form-group col">
            <div class="input-group">

              <div class="form-check form-check-inline ml-3">
                <label class="form-check-label" for="headerNameDefinition">Column header name :</label>
                <input class="form-check-input ml-3" type="input" name="goldStandardOptions" id="headerNameDefinition" value="PartialSelection" v-model="selectedKnowledgePropertyHeaderName" :disabled="selectedKnowledgeProperty === undefined">
              </div>

            </div>
          </div>
        </div>

        <div class="modal-footer mt-3">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
          <button type="button" class="btn btn-primary" :class="{'disabled': (selectedKnowledgeProperty === undefined)}" title="Not implemented yet" v-on:click="onAddColumnSubmit">Add this column</button>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import KnowledgeGraphApi from "../../../generatedApiClient/api/endpoints/KnowledgeGraphApi";
import CellContentDisplayer from './CellContentDisplayer';

let knowledgeGraphApiInstance = new KnowledgeGraphApi();

export default {
  name: "AddNewCPAModal",
  components: {
    CellContentDisplayer,
  },
  props: ["startColumnIndex", "startColumn", "headerName"],
  data() {
    return {
      autoLoadingForKnowledgeProperties: true,
      isLoadingKnowledgeProperties: true,
      choiceTextForKnowledgePropertySelection: "Choose a Knowledge Property...",
      newKnowledgePropertySelection: "Choose a Knowledge Property...",
//      choiceTextForKnowledgePropertySelection: "",
//      newKnowledgePropertySelection: "",
      knowledgePropertiesList: [],
      selectedKnowledgeProperty: undefined,
      selectedKnowledgePropertyHeaderName: undefined
    }
  },
  mounted() {
    console.log("[mounted] startColumn = ", this.startColumn);
  },
  updated() {
    console.log("[updated] startColumn = ", this.startColumn);
  },
  computed: {
    signedUser: function() {
      return (this.$store.state.identityIdentified !== undefined) ? this.$store.state.identityIdentified.email : undefined;
    },
    selectedProjectId: function() {
      return (this.$store.state.selectedProject !== undefined) ? this.$store.state.selectedProject.id : undefined;
    },
  },
  watch: {
    startColumn(val, oldVal) {
      console.log(`[watch] [startColumn] update ${(val && oldVal) ? '' : 'with missing value'}`);
      // reset knowledgePropertiesList, selectedKnowledgeProperty and newKnowledgePropertySelection
      this.knowledgePropertiesList = [];
      this.selectedKnowledgeProperty = undefined;
      this.newKnowledgePropertySelection = this.choiceTextForKnowledgePropertySelection;
      if (this.autoLoadingForKnowledgeProperties) {
        this.findKnowledgeProperties();
      }
    }
  },
  methods: {
    updateAuthJwtToken: function (apiInstance) {
      if (apiInstance && apiInstance.apiClient && apiInstance.apiClient.authentications && apiInstance.apiClient.authentications['AuthJWT']) {
        apiInstance.apiClient.authentications['AuthJWT'].accessToken = this.$store.state.identityIdentified.token;
      }
    },
    newKnowledgePropertySelectionChange: function() {
      console.log("[newKnowledgePropertySelectionChange] this.newKnowledgePropertySelection = ", this.newKnowledgePropertySelection);
      this.selectedKnowledgeProperty = this.knowledgePropertiesList.filter(elem => (elem.pLabel === this.newKnowledgePropertySelection))[0];
      this.selectedKnowledgePropertyHeaderName = (this.selectedKnowledgeProperty === undefined) ? undefined : this.newKnowledgePropertySelection;
    },
    findKnowledgeProperties: function() {
      const ceaInfindProperties = this.startColumn.map(ceaInStartColumn => {
        return {
          label: ceaInStartColumn.ceaLabel,
          uri: ceaInStartColumn.ceaLink ? ceaInStartColumn.ceaLink.replaceAll(new RegExp(/<a href="([^"]*)"([^<]*)<\/a>/g), '$1') : undefined
        }
      });
      console.log("[findKnowledgeProperties] ceaInfindProperties = ", JSON.stringify(ceaInfindProperties));
      this.isLoadingKnowledgeProperties = true;
      this.updateAuthJwtToken(knowledgeGraphApiInstance);
      knowledgeGraphApiInstance.findProperties(ceaInfindProperties)
        .then(findPropertiesResp => {
          console.log("[findKnowledgeProperties] [API] [findProperties] [OK]");
          console.log("[findKnowledgeProperties] findPropertiesResp = ", JSON.stringify(findPropertiesResp));

          findPropertiesResp.forEach(findPropertiesRespItem => {
            findPropertiesRespItem.propertyValues = findPropertiesRespItem.propertyValues.map(element => {
              if (element.length === 0) {
                return {
                  length: element.length,
                  sample: undefined,
                  sampleLabel: undefined,
                  sampleLink: undefined
                }
              } else {
                const isItem = findPropertiesRespItem.isItemProperty;
                const splittedUris = element.sample.split('::');
                let htmlLinks = '';
                splittedUris.forEach((splittedUri) => {
                  const splittedUriWithoutHeader = splittedUri.replace(/^(\(-\)|)http/g, 'http');
                  const splittedUriHeader = splittedUri.replace(/^(\(-\)|)http(.*)/g, '$1');
                  // const splittedUriQid = splittedUri.replace(/^(\(-\)|)http(.*)(\/([^/])?)/g, '$4');
                  const splittedUriQid = splittedUri.replace(/^(\(-\)|)http(.*)(\/(Property:|)([^/])?)/g, '$5');
                  const splittedUriTransformedLabel = `<a href="${splittedUriWithoutHeader}" target="_blank">${isItem ? splittedUriQid : element.sampleLabel}</a>`;
                  htmlLinks += (htmlLinks === '') ? '' : '::'
                  htmlLinks += `${splittedUriHeader}${splittedUriTransformedLabel}`;
                });
                return {
                  length: element.length,
                  sample: element.sample,
                  sampleLabel: element.sampleLabel,
                  sampleLink: htmlLinks
                }
              }
            });
          })
          this.knowledgePropertiesList = findPropertiesResp;
          this.isLoadingKnowledgeProperties = false;
        })
        .catch(findPropertiesError => {
          console.log("[findKnowledgeProperties] [API] [findProperties] [ERROR]", findPropertiesError);
        });
    },
    onAddColumnSubmit: function() {
      console.log("[onAddColumnSubmitfunction]");
      this.$emit('add-new-column', {
        startColumnIndex: this.startColumnIndex,
        property: this.selectedKnowledgeProperty,
        headerName: this.selectedKnowledgePropertyHeaderName
      });
    }
  }
}
</script>

<style scoped>

.modal {
  font-size: medium;
}

th {
  z-index: 5;
  position: sticky;
  top: 0px;
  background-color: whitesmoke;
}

</style>